import React from "react"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

export const MerchantDeclineError = () => (
  <>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
      <Typography variant="h3">
        <FormattedMessage defaultMessage="We're working on your request" />
      </Typography>
    </Box>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
      <Typography>
        <FormattedMessage defaultMessage="Unfortunately your request is taking longer than expected. We’ll send you an SMS as soon as the provider is approved." />
      </Typography>
    </Box>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })} />
  </>
)
